/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PermessoUtenteDto } from '../../models/permesso-utente-dto';

export interface ApiAuthPermesoUtenteListGet$Params {}

export function apiAuthPermesoUtenteListGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiAuthPermesoUtenteListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<PermessoUtenteDto>>> {
    const rb = new RequestBuilder(rootUrl, apiAuthPermesoUtenteListGet.PATH, 'get');
    if (params) {
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<PermessoUtenteDto>>;
        }),
    );
}

apiAuthPermesoUtenteListGet.PATH = '/api/auth/permeso-utente-list';
